import { api } from '../../api'

export const deleteChartService = async (id: string) => {
  await api.delete(`/api/backoffice/seatMaps/${id}`)
}
